<div class="hero">
  <div class="hero-inner">
    <div class="prog" [class.gone]="activeTab === 'compare'">
      <ng-container *ngFor="let s of steps; let last = last">
        <div class="ps" [ngClass]="stepClass(s.id)">
          <div class="psn">{{ s.id }}</div>
          <span class="psl">{{ s.label }}</span>
        </div>
        <div *ngIf="!last" class="pc" [class.done]="s.id < step"></div>
      </ng-container>
    </div>
    <h1>
      <span>Join the One Club.</span><br />
      <span class="line2">Get insured.</span>
    </h1>
  </div>
  <div class="htabs-wrap">
    <div class="htabs-inner">
      <div
        class="htab"
        [class.on]="activeTab === 'covered'"
        (click)="selectTab('covered')"
      >
        Get covered
      </div>
      <div
        class="htab"
        [class.on]="activeTab === 'compare'"
        (click)="selectTab('compare')"
      >
        Compare memberships
      </div>
      <a
        class="htab"
        [href]="portalUrl + '/#/pages/login'"
        target="_blank"
        rel="noopener noreferrer"
      >
        Existing members <span class="htab-arrow">→</span>
      </a>
    </div>
  </div>
</div>
